import React from 'react';
import test from '../../../../img/combobulate.svg';

function Logo() {
  return (
    <img
      src={test}
      alt="Combobulate Logo"
      style={{
        height: '30vh',
        margin: '0 auto',
        marginTop: '5%',
        width: '350px',
        objectFit: 'contain',
      }}
    />
  );
}

export default Logo;
